import { BusinessCategory } from '@sdk/authentication/types';
import gettext from '@sdk/lang/gettext';
import shiftColors from '@sdk/theme/shiftColors';

import { DEFAULT_POSITIONS, INDUSTRY_POSITIONS } from '../constants';

export type FormPosition = {
  placeholder: string;
  name: string;
  color: string;
  type: 'position';
};

const DEFAULT_COUNT = 3;
const DEFAULT_PLACEHOLDER = gettext('Position name');

export default function getDefaultPositions(industry: BusinessCategory): FormPosition[] {
  return new Array(DEFAULT_COUNT).fill(true).map((_, i) => getPositionForIndex(i, industry));
}

export function getPositionForIndex(index: number, industry: BusinessCategory): FormPosition {
  return {
    name: '',
    type: 'position',
    placeholder: getPlaceholder(index, industry),
    color: shiftColors[index] || shiftColors[0],
  };
}

function getPlaceholder(index: number, industry: BusinessCategory): string {
  const positions = INDUSTRY_POSITIONS[industry] ? INDUSTRY_POSITIONS[industry] : DEFAULT_POSITIONS;
  const example = gettext(positions[index])
    ? `, ${gettext('e.g.')} ${gettext(positions[index])}`
    : '';

  return `${DEFAULT_PLACEHOLDER}${example}` || gettext(DEFAULT_PLACEHOLDER);
}
